import { Badge, DataTable, PageHeader } from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { usePlatformAudit, usePlatformVenues } from "../../features/platform/queries.ts";
import type { PlatformAuditEntry } from "../../features/platform/types.ts";

export const Route = createFileRoute("/_app/audit")({ component: AuditScreen });

function AuditScreen() {
  const [venueId, setVenueId] = useState("");
  const { data: venues } = usePlatformVenues();
  const { data: entries, isLoading, error } = usePlatformAudit(venueId || undefined);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Audit Log"
        subtitle="Every platform action and tenant-data access, newest first (FR-SADMIN-080)."
      />
      <select
        aria-label="Filter by venue"
        value={venueId}
        onChange={(event) => setVenueId(event.target.value)}
        className="flex h-11 rounded-md border border-input bg-transparent px-3 text-sm"
      >
        <option value="">All venues</option>
        {(venues ?? []).map((venue) => (
          <option key={venue.id} value={venue.id}>
            {venue.name}
          </option>
        ))}
      </select>
      {error ? (
        <p role="alert" className="rounded-md bg-destructive/10 p-3 text-destructive text-sm">
          {error.message}
        </p>
      ) : null}
      <DataTable<PlatformAuditEntry>
        rows={entries ?? []}
        getRowKey={(row) => row.id}
        empty={
          <p className="text-muted-foreground text-sm">
            {isLoading ? "Loading…" : "No audit entries."}
          </p>
        }
        columns={[
          {
            key: "action",
            header: "Action",
            cell: (row) => <span className="font-mono text-xs">{row.action}</span>,
          },
          { key: "venue", header: "Venue", cell: (row) => row.venueName ?? "—" },
          {
            key: "actor",
            header: "Actor",
            cell: (row) => <Badge variant="outline">{row.actorType}</Badge>,
          },
          { key: "target", header: "Target", cell: (row) => row.targetType ?? "—" },
          {
            key: "at",
            header: "When",
            cell: (row) => new Date(row.createdAt).toLocaleString(),
          },
        ]}
      />
    </div>
  );
}
